export const NON_ADMIN_LABEL = 'Test Validator';
export const ADMIN_LABEL = 'Organization Administrator';

export const ADMIN = 'ADMIN';
export const SUPER_ADMIN = 'SUPER_ADMIN';
